// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../college-and-career-public/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".unicon[data-v-72949a05]{display:inline}", ""]);
// Exports
module.exports = exports;
